<template>
  <header>
        <div class="container mobile-col">
            <div class="col-md-12 mobile-col">
                <div class="col-md-3 col-xs-12">
                    <div class="logo-holder">
                        <img class="logo" src="static/images/logo.jpg">
                    </div>
                    <div class="back-btn-holder pull-left">
                        <a class="back-btn" href="http://www.bonesrestaurant.com/"><i class="fa fa-chevron-left" aria-hidden="true"></i> Bones Website</a>
                    </div>
                </div>
                <div class="col-md-7 col-md-offset-2 col-xs-12 mobile-col">
                    <div class="col-sm-9 col-xs-12 mobile-col">
                        <div class="sort-btns-holder pull-left">
                            <a :class="[{active: sorting=='name'}, 'sort-btn' ]" class="sort-btn" href="#" @click.prevent="sortBy('name')">A-Z <i :class="[{'fa-sort-asc': (sorting=='name' && order=='asc'),'fa-sort-desc': (sorting=='name' && order=='desc')}, 'fa' ]" aria-hidden="true"></i></a>
                            <a :class="[{active: sorting=='price'}, 'sort-btn' ]" href="#" @click.prevent="sortBy('price')">Price <i :class="[{'fa-sort-asc': (sorting=='price' && order=='asc'),'fa-sort-desc': (sorting=='price' && order=='desc')}, 'fa' ]" aria-hidden="true"></i></a>
                            <a :class="[{active: sorting=='vintage'}, 'sort-btn' ]" href="#" @click.prevent="sortBy('vintage')">Vintage <i :class="[{'fa-sort-asc': (sorting=='vintage' && order=='asc'),'fa-sort-desc': (sorting=='vintage' && order=='desc')}, 'fa' ]" aria-hidden="true"></i></a>
                            <a :class="[{active: sorting=='rating'}, 'sort-btn' ]" href="#" @click.prevent="sortBy('rating')">Rating <i :class="[{'fa-sort-asc': (sorting=='rating' && order=='asc'),'fa-sort-desc': (sorting=='rating' && order=='desc')}, 'fa' ]" aria-hidden="true"></i></a>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-12">
                        <div class="rating-holder">
                            <label class="rating-label" for="rating">Rating</label>
                            <label class="switch">
                                <input type="checkbox" id="rating">
                                <span @click="showRating()" class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="search-wrapper">
                            <input class="search" placeholder="Search" type="search" ref="search" v-model="query" @input="changed">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
  name: 'Filters',
  data () {
        return {
            query: ''
        }
    },
    props: [
        'sorting',
        'order'
    ],
    methods: {
        sortBy (sorting) {
            bus.$emit('app:sortby', sorting)
        },
        showRating (){
            bus.$emit('app:showrating');
        },
        changed () {
            this.$emit('input', this.$refs.search.value)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Filters.vue